import AmexShopSmallHeaderLogin from './AmexShopSmallHeaderLogin';

export default AmexShopSmallHeaderLogin;
